import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./dailymealcodes.component.html",
})
export class DailyMealCodesComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		HomeroomID: 0,
		GradeLevelID: 0,
		AcademyID: 0,
		GroupID: 0,
		MealSubsidyTypeID: 0,
		startDate: new Date(),
		endDate: new Date(),
		MealID: 0,
		ImageLogo: "",
	};
	schoolList: any = [];
	homeroomList: any = [];
	gradeList: any = [];
	academyList: any = [];
	groupList: any = [];
	mealList: any = [];
	mealSubsidyList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ReportID: number = 160;
	subscription: any;

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(160);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.HomeroomList();
		this.AcademyList();
		this.GradeList();
		this.GroupList();
		this.MealList();
		this.MealSubsidyList();
		this.loadLogolist();
	}

	private HomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.reportService.HomeroomGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.homeroomList = response;

				if (this.homeroomList.length > 1) {
					this.homeroomList.unshift({
						HomeroomID: 0,
						HomeroomDesc: "All Homerooms",
					});
					this.report.HomeroomID = this.homeroomList[0].HomeroomID;
				} else {
					this.report.HomeroomID = this.homeroomList[0].HomeroomID;
				}
			},
			(error) => {}
		);
	}

	private AcademyList() {
		this.report.AcademyID = 0;
		var result = this.reportService.AcademyGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.academyList = response;

				if (this.academyList.length >= 0) {
					this.academyList.unshift({
						AcademyID: 0,
						AcademyDesc: "All Academies",
					});
					this.report.AcademyID = this.academyList[0].AcademyID;
				} else {
					this.report.AcademyID = this.academyList[0].AcademyID;
				}
			},
			(error) => {}
		);
	}

	private GradeList() {
		this.report.GradeLevelID = 0;
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.gradeList = response;

				if (this.gradeList.length > 1) {
					this.gradeList.unshift({
						GradeLevelID: 0,
						GradeLevelDesc: "All Grades",
					});
					this.report.GradeLevelID = this.gradeList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.gradeList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private GroupList() {
		this.report.GroupID = 0;

		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.groupList = response;

				if (this.groupList.length >= 0) {
					this.groupList.unshift({
						GroupID: 0,
						GroupName: "All Groups",
					});
					this.report.GroupID = this.groupList[0].GroupID;
				} else if (this.groupList.length == 1) {
					this.report.GroupID = this.groupList[0].GroupID;
				}
				// else  {
				//     this.groupList.push({
				//         GroupID: 0,
				//         GroupName: "No Record found"
				//     })
				// }
			},
			(error) => {}
		);
	}

	private MealList() {
		this.report.MealID = 0;
		var result = this.reportService.MealGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.mealList = response;

				if (this.mealList.length > 1) {
					this.mealList.unshift({
						MealID: -1,
						MealName: "All Meals",
					});
					this.report.MealID = this.mealList[0].MealID;
				} else if (this.mealList.length == 1) {
					this.report.MealID = this.mealList[0].MealID;
				}
				// else  {
				//     this.mealList.push({
				//         MealID: 0,
				//         MealName: "No Record found"
				//     })
				// }
			},
			(error) => {}
		);
	}

	private MealSubsidyList() {
		this.report.MealSubsidyTypeID = 0;

		var result = this.reportService.MealSubsidyGetList();
		result.subscribe(
			(response) => {
				this.mealSubsidyList = response;

				if (this.mealSubsidyList.length > 1) {
					this.mealSubsidyList.unshift({
						MealSubsidyTypeID: -1,
						MealSubsidyTypeDesc: "All Meal Subsidies",
					});
					this.report.MealSubsidyTypeID = this.mealSubsidyList[0].MealSubsidyTypeID;
				} else {
					this.report.MealSubsidyTypeID = this.mealSubsidyList[0].MealSubsidyTypeID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.HomeroomID) {
		//     this.errorMessage = "Select the Homeroom";
		//     return
		// }

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 160;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.report.SchoolID + "|SchoolID";

		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";
		strParam += "," + this.report.AcademyID + "|AcademyID";
		strParam += "," + this.report.HomeroomID + "|HomeroomID";
		strParam += "," + this.report.GroupID + "|GroupID";
		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";
		strParam += "," + this.report.MealID + "|MealID";
		strParam += "," + this.report.MealSubsidyTypeID + "|MealSubsidyTypeID";
		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
